var React = require('react');

function ChevronUp (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"arrow / chevron"),React.createElement("g",{"id":"//-Symbols","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","strokeLinecap":"round","strokeLinejoin":"round","key":1},React.createElement("g",{"id":"icons/Navigation/Arrow-Up","transform":"translate(-5.014578, -7.800424)","stroke":"#FFFFFF","strokeWidth":"2"},React.createElement("path",{"d":"M15.4788636,18.2647093 L9.05029297,12.0147103 L15.4788636,5.76470926","id":"arrow-/-chevron","transform":"translate(12.264578, 12.014709) rotate(-270.000000) translate(-12.264578, -12.014709) "})))]);
}

ChevronUp.defaultProps = {"width":"14.5000012px","height":"8.42857128px","viewBox":"0 0 14.5000012 8.42857128","version":"1.1"};

module.exports = ChevronUp;

ChevronUp.default = ChevronUp;
